import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import msal, { setUser } from 'lib/msal';
import * as microsoftTeams from "@microsoft/teams-js";
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

var AuthenticationCallback = /*#__PURE__*/function (_Component) {
  _inherits(AuthenticationCallback, _Component);

  var _super = _createSuper(AuthenticationCallback);

  function AuthenticationCallback(props) {
    var _this;

    _classCallCheck(this, AuthenticationCallback);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    _this.state = {
      redirect: null
    };
    return _this;
  }

  _createClass(AuthenticationCallback, [{
    key: "navigateTo",
    value: function navigateTo(path) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: path
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var consentResult, platform;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (window.location.search.indexOf('admin_consent') > -1) {
                  consentResult = {
                    state: this.getParameterByName('state'),
                    consent: this.getParameterByName('admin_consent')
                  };
                  platform = this.getParameterByName('platform');

                  if (platform == "teams") {
                    microsoftTeams.authentication.notifySuccess(JSON.stringify(consentResult));
                  } else {
                    window.opener.onPopupDataReceived(JSON.stringify(consentResult));
                    window.close();
                  }
                }

                console.log("Window location", window.location.hash);

                if (window.location.hash.indexOf('code') > -1) {
                  msal.handleRedirectPromise().then(function (response) {
                    console.log("MSAL response", response);

                    if (response != null) {
                      setUser(response.account.username);
                    }

                    var platform = _this2.getParameterByName('platform');

                    if (platform == "teams") {
                      console.log(msal.getAllAccounts());
                      microsoftTeams.authentication.notifySuccess("Login Success");
                    } else {
                      if (response.state) {
                        var responseStateObject = JSON.parse(response.state);

                        _this2.setState({
                          redirect: responseStateObject.url
                        });
                      } else {
                        _this2.setState({
                          redirect: "/"
                        });
                      }
                    }
                  })["catch"](function (reason) {
                    console.log("MSAL ERROR", reason);
                    microsoftTeams.authentication.notifyFailure(reason);
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.redirect) {
        return this.navigateTo(this.state.redirect);
      }

      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return AuthenticationCallback;
}(Component);

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(AuthenticationCallback);